import { Industries } from '@platform/client';
import { MultiSelectCategory, MultiSelectCategoryDropdown } from '@platform/components';
import { UseFormRegisterReturn } from 'react-hook-form';

type IndustrySelectionDropdownProps = {
  selectedIndustries: string[];
  onIndustriesSelectionChange: (selectedIndustries: string[]) => void;
  register?: () => UseFormRegisterReturn<string>;
  errors?: Record<string, { message: string } | undefined>;
  placeholder?: string;
  label: string;
  selectionLimit?: number;
};

export const IndustrySelectionDropdown = (props: IndustrySelectionDropdownProps) => {
  const {
    selectedIndustries,
    onIndustriesSelectionChange,
    register,
    errors,
    placeholder,
    label,
    selectionLimit,
  } = props;
  const industriesList = Industries.useGetIndustries();
  const classificationOptions =
    industriesList.isSuccess ?
      Array.from(
        industriesList.data
          .reduce<Map<string, MultiSelectCategory>>((map, industry) => {
            if (!map.has(industry.classification)) {
              map.set(industry.classification, {
                name: industry.classification,
                options: [],
              });
            }
            // eslint-disable-next-line
            map.get(industry.classification)!.options.push(industry.name);
            return map;
          }, new Map())
          .values(),
      )
    : [];

  return (
    <div className='w-[350px]'>
      <MultiSelectCategoryDropdown
        selectedItems={selectedIndustries}
        onSelectionChange={onIndustriesSelectionChange}
        categories={classificationOptions}
        selectionLimit={selectionLimit}
        placeholder={placeholder || 'Select industries'}
        label={label}
        error={errors?.industries?.message}
        register={register}
      />
    </div>
  );
};
